import React from 'react';
import { SectionComponentProps } from './register';

export const containerSizes = ['xs', 'sm', 'md', 'lg'] as const;

export type ContainerSize = (typeof containerSizes)[number];

export type SectionProps = SectionComponentProps<ContainerSize>;

/**
 * CMS Section component that overrides Builder's core section,
 * used for setting the width of the content via the container utility.
 */
export const Section: React.FunctionComponent<SectionProps> = ({ size, children }) => (
	<div className={`u-container-${size}`}>{children}</div>
);
